var NotebookExecutionType;
( (function(NotebookExecutionType) {
    NotebookExecutionType[NotebookExecutionType["cell"] = 0] = "cell";
    NotebookExecutionType[NotebookExecutionType["notebook"] = 1] = "notebook";
})(NotebookExecutionType || (NotebookExecutionType = {})));
export { NotebookExecutionType };
